module.exports = __webpack_public_path__ + "img/v4-header.82edc21d.svg";